import type { RenewalLostMeta } from '@/types';

const RENEWAL_LOST_REASON_LABELS: Record<string, string> = {
  'placed-with-another-insurer': 'Placed with another insurer',
  'client-gone-to-competitor': 'Client gone to a competitor',
  'pricing-too-high': 'Pricing too high',
  'reduction-of-risks': 'Reduction of risks (new policy)',
};

export function getRenewalLostReasonLabel(reason: string | undefined): string | null {
  if (!reason?.trim()) return null;
  return RENEWAL_LOST_REASON_LABELS[reason] ?? reason;
}

export function parseRenewalLostMeta(meta: unknown): RenewalLostMeta | null {
  if (!meta || typeof meta !== 'object' || Array.isArray(meta)) return null;

  const record = meta as Record<string, unknown>;
  const reason = typeof record.reason === 'string' ? record.reason : undefined;
  const notes = typeof record.notes === 'string' ? record.notes : undefined;
  const insurer = typeof record.insurer === 'string' ? record.insurer : undefined;
  const policyNumber = typeof record.policyNumber === 'string' ? record.policyNumber : undefined;

  if (!reason && !notes && !insurer && !policyNumber) return null;

  return { reason, notes, insurer, policyNumber };
}
